<template>
  <div :class="`col-${width || 100}`">
    <div class="mb-4">
      <span class="label">{{ label }}</span>
    </div>
    <v-radio-group row
      single-line
      v-validate="validator"
      data-vv-validate-on="change|input"
      :error-messages="errors.first(field)"
      :name="field"
      v-model="value">
      <v-radio v-for="option in options"
        :key="option.id"
        :label="option.label"
        :value="option.value" />
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: 'FormRadio',
  inject: ['$validator'],
  props: {
    id: String,
    label: String,
    name: String,
    options: {
      type: Array,
      default: () => {}
    },
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    },
    mask: {
      default: null,
      type: String
    },
    placeholder: {
      default: null,
      type: String
    },
    extra_data: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    value: ''
  }),
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value)
    }
  },
  computed: {
    componentValue() {
      const obj = { [this.field]: this.value }
      return this.extra_data ? { extra_data: obj } : obj
    }
  },
  mounted() {
    if (this.$store.getters.TOKEN && this.$store.getters.USER_INFO[this.field]) {
      this.value = this.$store.getters.USER_INFO[this.field]
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-messages__message {
  padding-left: 12px;
  margin-bottom: 8px;
}
</style>
